import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Input,
} from "reactstrap";
import Select from "react-select";
import toast from "react-hot-toast";

const EditOrderModal = ({
  isOpen,
  toggle,
  selectedOrder,
  status,
  setStatus,
  onSave,
}) => {
  const [remarks, setRemarks] = useState("");
  const [isCompleted, setIsCompleted] = useState(false); // Track if status is "Completed"

  const statusOptions = [
    { label: "Ongoing", value: 1 },
    { label: "Received", value: 2 },
    { label: "Processing", value: 3 },
    { label: "Ready", value: 4 },
    { label: "Delivering", value: 5 },
    { label: "Cancelled", value: 6 },
    { label: "Completed", value: 7 },
  ];

  const selectedOption = statusOptions.find((option) => option.label === status);

  // Check if the status is "Completed" when the modal opens or status changes
  useEffect(() => {
    if (status === "Completed") {
      setIsCompleted(true);
      toast.error("Order is already completed and cannot be edited.");
    } else {
      setIsCompleted(false);
    }
  }, [status]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop={true}>
      <ModalHeader toggle={toggle}>Edit Order Status</ModalHeader>
      <ModalBody>
        {selectedOrder && (
          <Form>
            <Row className="mb-3">
              <Col>
                <div className="border rounded p-3 bg-light">
                  <h6 className="mb-2">Order Details</h6>
                  <p className="mb-1">
                    <strong>Customer Contact:</strong>{" "}
                    {selectedOrder.customerContact || "N/A"}
                  </p>
                  <p className="mb-1">
                    <strong>Order Ref:</strong> {selectedOrder.orderRef}
                  </p>
                  <p className="mb-0">
                    <strong>Created Date:</strong>{" "}
                    {new Date(selectedOrder.createdDate).toLocaleString()}
                  </p>
                </div>
              </Col>
            </Row>
            <FormGroup>
              <Label for="orderStatus">Order Status</Label>
              <Select
                id="orderStatus"
                name="orderStatus"
                options={statusOptions}
                value={selectedOption}
                onChange={(selected) => setStatus(selected.value)}
                placeholder="Select a status"
                isSearchable={true}
                isDisabled={isCompleted} // Disable if status is "Completed"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    minHeight: "38px",
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected ? "#5B71B9" : "white",
                    color: state.isSelected ? "white" : "black",
                  }),
                }}
              />
            </FormGroup>
            <FormGroup>
              <Label for="remarks">Remarks</Label>
              <Input
                id="remarks"
                name="remarks"
                type="textarea"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                placeholder="Enter remarks"
                disabled={isCompleted} // Disable if status is "Completed"
              />
            </FormGroup>
          </Form>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => onSave(remarks)}
          disabled={isCompleted} // Disable save button if status is "Completed"
        >
          Save Changes
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditOrderModal;